var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { useDropdownMenuContext } from '../dropdown-menu-context';
import { styled } from '../../styled';
var dropdownMenuItemComponentName = 'QuantumDropdownMenuItem';
var Root = styled('div', { name: dropdownMenuItemComponentName, slot: 'Root' })(function (_a) {
    var theme = _a.theme, ownerState = _a.ownerState;
    return (__assign({ padding: theme.spacing(0.5, 1), borderRadius: 6 }, (ownerState.size === 'large' && {
        padding: theme.spacing(0.75, 1.5),
    })));
});
/** wrapper component to provide proper spacing inside a DropdownMenu */
export var DropdownMenuItem = React.forwardRef(function (props, ref) {
    var children = props.children, rootProps = __rest(props, ["children"]);
    var size = useDropdownMenuContext().size;
    return (React.createElement(Root, __assign({}, rootProps, { ownerState: { size: size }, ref: ref }), children));
});
